"use strict";
/* eslint-disable @typescript-eslint/no-var-requires */
var logger = require('../logger').logger;
var _a = require('./sources'), whiteLabelsList = _a.list, partnersNamesList = _a.partners;
var defaultSendSource = 'sendfx';
var newDefaultSendSource = 'sendpayments';
var sendUrl = "".concat(defaultSendSource, ".net");
var newSendDomain = 'sendpayments.com';
var getDomain = function (_a, _b) {
    var _c = _a.source, source = _c === void 0 ? defaultSendSource : _c;
    var list = _b.sourcesList, ENV = _b.ENV;
    logger.log('getDomain', 'source', source);
    logger.log('getDomain', 'sourcesList', list);
    logger.log('getDomain', 'ENV', ENV);
    var currentSource = list[source || defaultSendSource];
    if (!currentSource) {
        throw Error('invalid email source');
    }
    if (source === defaultSendSource) {
        if (ENV === 'prod') {
            return sendUrl;
        }
        return sendUrl;
    }
    if (ENV === 'prod') {
        return newSendDomain;
    }
    return newSendDomain;
};
var getSiteSubdomain = function (_a, _b) {
    var _c = _a.source, source = _c === void 0 ? defaultSendSource : _c;
    var list = _b.sourcesList, ENV = _b.ENV;
    logger.log('getSiteSubdomain', 'source', source);
    logger.log('getSiteSubdomain', 'sourcesList', list);
    logger.log('getSiteSubdomain', 'ENV', ENV);
    var currentSource = list[source || defaultSendSource];
    if (!currentSource) {
        throw Error('invalid email source');
    }
    if (source === defaultSendSource || source === newDefaultSendSource) {
        if (ENV.includes('prod')) {
            return "portal";
        }
        if (ENV.includes('uat')) {
            return "portal-uat.env";
        }
        if (ENV.includes('qa')) {
            return "portal-release.env";
        }
        return "portal-".concat(ENV, ".env");
    }
    if (ENV === 'prod') {
        return "".concat(currentSource);
    }
    if (ENV.includes('prod')) {
        return currentSource;
    }
    if (ENV.includes('uat')) {
        return "".concat(currentSource, "-uat.env");
    }
    if (ENV.includes('qa')) {
        return "".concat(currentSource, "-release.env");
    }
    return "".concat(currentSource, "-").concat(ENV, ".env");
};
var getPartnerName = function (_a, _b) {
    var _c = _a.source, source = _c === void 0 ? defaultSendSource : _c;
    var list = _b.sourcesList;
    logger.log('getPartnerName', 'source', source);
    logger.log('getPartnerName', 'sourcesList', list);
    var currentSource = list[source || defaultSendSource];
    if (!currentSource) {
        throw Error('invalid email source');
    }
    return list[source || defaultSendSource];
};
module.exports = {
    getDomain: getDomain,
    getSiteSubdomain: getSiteSubdomain,
    getPartnerName: getPartnerName,
    whiteLabelsList: whiteLabelsList,
    partnersNamesList: partnersNamesList,
};
//# sourceMappingURL=index.js.map